import {
  Recipe,
  Pizza,
  Allergen,
  Categories,
  Unit,
  Alert,
  CircularAlert,
  Filter
} from "ceicons";

const menuEntries = [
  {
    name: "title.recipes",
    icon: Recipe,
    permissions: ["rrhh"],
    path: "/recipes",
    exact: true,
  },
  {
    name: "title.ingredients",
    icon: Pizza,
    permissions: ["rrhh", "chief"],
    path: "/ingredients",
    exact: true,
  },
  {
    name: "title.allergens",
    icon: Allergen,
    path: "/allergens",
    permissions: ["rrhh"],
    exact: true,
  },
  {
    name: "title.categories",
    icon: Categories,
    path: "/categories",
    exact: true,
    permissions: ["rrhh"],
  },
  {
    name: "title.units",
    icon: Unit,
    path: "/units",
    exact: true,
    permissions: ["rrhh"],
  },
  {
    name: "title.alerts",
    icon: Alert,
    path: "/alerts",
    exact: true,
    permissions: ["rrhh"],
  },
  {
    name: "title.general-info",
    icon: CircularAlert,
    path: "/general-info",
    exact: true,
    permissions: ["rrhh"],
  },
  {
    name: "title.filters",
    icon: Filter,
    path: "/filters",
    exact: true,
    permissions: ["rrhh"],
  },
  // {
  //   name: "Turnos",
  //   icon: Filters,
  //   permissions: ["rrhh"],
  //   children: [
  //     {
  //       name: "Horarios",
  //       icon: Logout,
  //       path: "/shifts",
  //       exact: true,
  //       permissions: ["rrhh"]
  //     }
  //   ]
  // }
];
export default menuEntries;
